export function sanitiseComposeResponse(composeResponse: any): any {
	return {
		...(composeResponse as unknown as Record<string, unknown>),
		resolutions: composeResponse.resolutions.map((resolution: any) => ({
			...(resolution as unknown as Record<string, unknown>),
			errors: resolution.errors?.filter((error: any) => {
				if (error.code === 'crs.BET_SLIP_MISSING_STAKE') {
					console.log("Removing error crs.BET_SLIP_MISSING_STAKE - not needed for this app")
					return false
				}
				return true
			}),
		})),
	} as unknown
}